import React from 'react';
import styles from './formulari.module.scss';
// @ts-ignore
import BotoComponent from 'components/corporatiu/Boto';

const Boto = BotoComponent as React.ComponentType<{
    text?: string;
    estil?: string;
    tag?: string;
    [key: string]: any;
}>;

type FormulariEntitatsProps = {
    nom?: string;
    [key: string]: any;
};

export default function FormulariEntitats(props: FormulariEntitatsProps) {
    const { nom } = props;
    return (
        <div className={styles.formulari}>
            <div className={styles.dades}>
                <span>(*) Camps obligatoris</span>
            </div>
            <form action='https://www.3cat.cat/su/Register' method='post' name={nom} encType='multipart/form-data' id={nom}>
                <div className={styles.dades}>
                    <div className={styles.formField}>
                        <label htmlFor='NOM' className={styles.required}>
                            Nom*
                        </label>
                        <input type='text' id='NOM' name='NOM' required />
                    </div>
                    <div className={styles.formField}>
                        <label htmlFor='CORREU'>Adreça electrònica</label>
                        <input type='email' id='CORREU' name='CORREU' />
                    </div>
                    <div className={styles.formField}>
                        <label htmlFor='TELEFON'>Telèfon de contacte</label>
                        <input type='text' id='TELEFON' name='TELEFON' />
                    </div>
                    <div className={styles.formField}>
                        <label htmlFor='POBLACIO'>Població</label>
                        <input type='text' id='POBLACIO' name='POBLACIO' />
                    </div>
                    <div className={styles.formField}>
                        <label htmlFor='NOM_ENT' className={styles.required}>
                            Nom de l&apos;entitat*
                        </label>
                        <input type='text' id='NOM_ENT' name='NOM_ENT' required />
                    </div>
                    <div className={styles.formField}>
                        <label htmlFor='NUM_ENT'>Número d&apos;entitat (si ja estàs inscrit)</label>
                        <input type='text' id='NUM_ENT' name='NUM_ENT' />
                    </div>

                    <div className={styles.formField}>
                        <label htmlFor='TEXT'>El teu missatge*</label>
                        <textarea id='TEXT' name='TEXT' maxLength={1000} rows={4} required />
                    </div>

                    <div className={styles.formField}>
                        <label htmlFor='IMGID'>Escriu el codi de la imatge</label>
                        <div className={styles.img_captcha}>
                            <img
                                alt='Imatge del codi captcha'
                                src={`https://www.3cat.cat/su/shared/image.jsp?imgId=${Math.random()}`}
                            />
                            <input value='IMGID' id='hiImgNumber' name='hiImgNumber' type='hidden' />
                        </div>
                        <input name='IMGID' id='IMGID' type='text' className={styles.camp_captcha} required />
                    </div>
                    <div className={styles.formField}>
                        <input name='tos_checkbox' id='tos_checkbox' type='checkbox' required />
                        <label htmlFor='tos_checkbox'>
                            He llegit i accepto la{' '}
                            <a href='https://www.3cat.cat/avis-legal/privacitat/fundacio-la-marato/' className={styles.linkForm}>
                                política de privacitat*
                            </a>
                        </label>
                    </div>

                    <input name='hiTarget' type='hidden' value='tv3/marato/contacta-faq/ok/' />
                    <input name='hiErrTarget' type='hidden' value='tv3/marato/contacta-faq/ko/' />
                    <input type='hidden' name='hiPortal' value='tvc'></input>
                    <input type='hidden' name='hiRegServiceId' value='MRT_CONTACTFAQ' />
                    <input type='hidden' name='hiServiceId' value='MRT_CONTACTFAQ' />
                    <input type='hidden' name='from' value='no_reply@tv3.cat' />
                    <input type='hidden' name='hiAction' value='254' />

                    <div>
                        <Boto text='Envia' estil='neutral' tag='button' />
                    </div>
                </div>
            </form>
        </div>
    );
}
